import { authApi, type RemoveSessionResponse } from "@b2bportal/auth-api";
import { axiosInstance } from "@hopper-b2b/api";

export const endSessionPut = async (): Promise<RemoveSessionResponse> => {
  try {
    const response = await authApi(axiosInstance).apiV0AuthSessionRemovePut();
    return response.data;
  } catch (error) {
    console.error("End session error:", error);
    throw Error("End session error");
  }
};

export const endSession = (): Promise<RemoveSessionResponse> => endSessionPut();

export default endSession;
